import { module } from 'modujs';

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
};

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.submitBind = this.handleSubmit.bind(this)

        this.el.addEventListener("submit", this.submitBind);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.el.classList.add(CLASS.IS_LOADING)

        let formData = new FormData(event.target)

        fetch('/wp-json/formsubmit/newsletter', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(result => {
            this.el.reset();
            if(this.el.dataset.type == 'event'){
                fetch('/wp-json/formsubmit/vache', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(result => {

                })
                .catch(error => {
                    console.error('Error:', error);
                });
                this.el.querySelector('.c-newsletter_form_feedback').innerHTML = "Merci, regardez vos courriels pour trouver votre code promo.";
                this.el.querySelector('.js-form-news').display = 'none';
            }
            this.el.classList.add(CLASS.IS_SUCCESS)
            this.el.classList.remove(CLASS.IS_LOADING)
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    destroy() {
        super.destroy()
        this.el.removeEventListener("submit", this.submitBind);
    }
}
